import { Checkbox } from '@repo/videa-components/src/ui/checkbox';
import { Input } from '@repo/videa-components/src/ui/input';
import { Label } from '@repo/videa-components/src/ui/label';
import {
  RadioGroup,
  RadioGroupItem,
} from '@repo/videa-components/src/ui/radio-group';

import type { TImageSets } from '../state';

export const TEETH_IMAGE_SETS_VALUES = {
  All: 'all',
  Selected: 'selected',
};

export const FormCheckbox = ({
  onChange,
  value,
  label,
  id,
}: {
  onChange: (value: boolean) => void;
  value: boolean;
  label: string;
  id?: string;
}) => {
  return (
    <div className="vai-flex vai-items-center vai-space-x-2">
      <Checkbox
        onCheckedChange={onChange}
        checked={value}
        className={`claim-summary-${id}`}
      />
      <Label className="vai-text-sm vai-font-medium vai-leading-none vai-peer-disabled:vai-cursor-not-allowed vai-peer-disabled:vai-opacity-70">
        {label}
      </Label>
    </div>
  );
};

export const FormInput = ({
  onChange,
  value,
  label,
  placeholder,
}: {
  onChange: (value: string) => void;
  value: string;
  label: string;
  placeholder: string;
}) => {
  return (
    <div className="vai-flex vai-items-center vai-gap-2 vai-w-full">
      <div className="vai-w-32 vai-text-sm vai-font-medium">{label}</div>
      <div className="vai-flex-1">
        <Input
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          value={value}
        />
      </div>
    </div>
  );
};

export const FormRadioGroupImageSets = ({
  value,
  onChange,
}: {
  value: TImageSets;
  onChange: (value: TImageSets) => void;
}) => {
  return (
    <RadioGroup defaultValue={value} onValueChange={onChange}>
      <div className="vai-flex vai-justify-center vai-gap-12">
        <div className="vai-flex vai-items-center vai-space-x-2">
          <RadioGroupItem
            value={TEETH_IMAGE_SETS_VALUES.All}
            id={TEETH_IMAGE_SETS_VALUES.All}
            checked={value === TEETH_IMAGE_SETS_VALUES.All}
          />
          <Label htmlFor={TEETH_IMAGE_SETS_VALUES.All}>
            Include all images
          </Label>
        </div>
        <div className="vai-flex vai-items-center vai-space-x-2 vai-mr-3">
          <RadioGroupItem
            value={TEETH_IMAGE_SETS_VALUES.Selected}
            id={TEETH_IMAGE_SETS_VALUES.Selected}
            checked={value === TEETH_IMAGE_SETS_VALUES.Selected}
          />
          <Label htmlFor={TEETH_IMAGE_SETS_VALUES.Selected}>
            Include only images for selected teeth
          </Label>
        </div>
      </div>
    </RadioGroup>
  );
};
